const GUEST_ID_KEY = "fibula_guest_id";
const GUEST_DAILY_KEY = "fibula_guest_daily";

export function guestId() {
  let id = localStorage.getItem(GUEST_ID_KEY);
  if (!id) {
    id = crypto.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(GUEST_ID_KEY, id);
  }
  return id;
}

export function readGuestDaily() {
  try { return JSON.parse(localStorage.getItem(GUEST_DAILY_KEY)) || {}; } catch { return {}; }
}

export function writeGuestDaily(map) {
  localStorage.setItem(GUEST_DAILY_KEY, JSON.stringify(map));
}

export function guestStreak(dates, today) {
  const d = new Date(`${today}T00:00:00Z`);
  if (!dates.has(today)) d.setUTCDate(d.getUTCDate() - 1);
  let n = 0;
  while (dates.has(d.toISOString().slice(0, 10))) { n++; d.setUTCDate(d.getUTCDate() - 1); }
  return n;
}

export const utcToday = () => new Date().toISOString().slice(0, 10);

export function lastNDates(n, today = utcToday()) {
  const d = new Date(`${today}T00:00:00Z`);
  const out = [];
  for (let i = 0; i < n; i++) {
    out.unshift(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() - 1);
  }
  return out;
}
